<script>
import {cancelOperation, downloadInv, getInvoices} from "@/api/subscriptions";
import {mapGetters} from "vuex";
import moment from "moment/moment";
import {show} from "../../../../api/admin/workspaces";

export default {
  name: 'SubscriptionInvoices',
  data() {
    this.load()
    return {
      page: 1,
      isFetch: true,
      invoices: [],
      show_card: false,
      total: 0,
      invoiceItem: {},
      headers: [
        {text: 'Сумма', value: 'cost'},
        {text: 'Ед. измерения', value: 'unit'},
        {text: 'Статус операции', value: 'operation_state'},
        {text: 'Номер счета', value: 'id'},
        {text: 'Дата оплаты', value: 'updated_at'},
        {text: 'Назначение', value: 'purpose'},
        {text: 'Срок действия', value: 'expired'},
        {text: 'Дата создания', value: 'created_at'},
        {text: 'Действие', value: 'action'}
      ],
      options: {
        itemsPerPage: 10,
        page: 1
      }
    }
  },
  watch: {
    options: {
      handler() {
        this.load();
      },
      deep: true,
    }
  },
  methods: {
    show,
    closeModal() {
      this.show_card = false
    },
    async load() {
      await getInvoices(this.options.page, this.options.itemsPerPage).then(
          (json) => {
            this.invoices = json.data.data
            this.isFetch = false
            this.total = json.data.total
          }
      )
    },
    deleteInvoice(item){
      if (confirm('Вы точно хотите удалить счет №' + item.id + '?')) {
        cancelOperation(item.id)
            .then(
                () => {
                  item.operation_state = 0;
                }
            )
      }
    },
    downloadInvoice(id) {
      downloadInv(id).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data], {
          type:
              'application/pdf'
        }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'invoice.pdf');
        document.body.appendChild(link);
        link.click();
      }).catch((error) => {
        alert('Произошла ошибка, возможно счет уже не актуален.')
        console.log(error.response.data.text())
      })
    },
    expiredDate(item) {
      return moment(item.created_at).add(1, 'month');
    },
    diffDays(item) {
      const diff = this.expiredDate(item).diff(moment(), 'days')
      return diff > 0 ? diff : 0
    },
    startDate(item) {
      return moment(item.subscription.subscription_finish_date, 'YYYY-MM-DD').add(-1 * item.subscription.period, 'M')
    }
  },
  computed: {
    moment() {
      return moment
    },
    ...mapGetters('user', ['USER_ID']),
    ...mapGetters('workspace', ['ID_WORK_SPACE']),
    invoiceList() {
      return this.invoices.filter(
          (item) => item.operation_state !== 0
      )
    }
  }
}
</script>

<template>
  <div class="ais24--subscription">
    <div class="ais24--container">
      <div>
        <header class="ais24--header">
          <h2 class="ais24--title">Информация о счетах</h2>
        </header>
        <v-data-table
            :headers="headers"
            :items="invoiceList"
            :options.sync="options"
            :server-items-length="total"
            :loading="isFetch"
            loading-text="Загрузка данных... Ожидайте"
            :footer-props="{itemsPerPageOptions: [10, 20, 50, 100]}"
            class="invoices"
        >
          <template v-slot:item.unit>
            руб.
          </template>
          <template v-slot:item.created_at="{ item }">
            {{ moment(item.created_at).format('DD.MM.YYYY') }}
          </template>
          <template v-slot:item.expired="{ item }">
            <template v-if="item.operation_type === 1 &&  item.payments[0] && item.payments[0].invoice_id && diffDays(item) > 0">
              {{ diffDays(item) }} дней
              <v-tooltip top>
                <template v-slot:activator="{on, attrs}">
                  <span class='fa fa-icon fa-info-circle' v-on="on" v-bind="attrs"/>
                </template>
                При неоплате счета до указанного срока ({{ expiredDate(item).format('DD.MM.YYYY') }}), счет будет
                автоматически удален
              </v-tooltip>
            </template>
          </template>
          <template v-slot:item.updated_at="{ item }">
            {{ item.operation_state === 2 ? moment(item.updated_at).format('DD.MM.YYYY') : '-' }}
          </template>
          <template v-slot:item.purpose="{ item }">
            <template v-if="item.operation_type === 1">
              {{ item.subscription_id || item.services.id ? 'оплата подписки' : 'пополнение баланса' }}
            </template>
            <template v-else>
              оплата подписки
            </template>
          </template>
          <template v-slot:item.cost="{item}">
            <!--            {{ item.operation_type === 1 ? item.cost : -1 * item.cost }}-->
            {{ item.cost - item.balance - item.discount }}
          </template>
          <template v-slot:item.operation_state="{ item }">
            <span :class="item.operation_state === 1 ? 'bg-danger' : 'bg-success'">
            {{ item.operation_state === 1 ? 'ожидает' : 'оплачен' }}
            </span>
          </template>
          <template v-slot:item.action="{item}">
            <v-menu
                bottom
                left
                v-if="item.subscription || item.operation_type === 1 &&  item.payments[0] && item.payments[0].invoice_id"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item v-if="item.subscription">
                  <v-list-item-title>
                    <span @click="show_card = true;invoiceItem=item" class="show-final-calculation">просмотреть расчет</span>
                    <!--                        <v-card-title>-->
                    <!--                          <span class="text-h5">Счет <strong-->
                    <!--                              @click="downloadInvoice(item.payments[0].invoice_id)">{{item.id}}</strong>-->
                    <!--                          </span>-->
                    <!--                        </v-card-title>-->
                    <!--                        <v-card-text>-->
                    <!--                          <v-container>-->
                    <!--                            <v-col>-->
                    <!--                              <span class="cost">{{item.cost}} руб.</span>-->
                    <!--                              <span class="payment-paid" v-if="item.operation_state === 2">оплачен</span>-->
                    <!--                              <span class="payment-unpaid" v-if="item.operation_state === 1">не оплачен</span>-->
                    <!--                              <br />-->
                    <!--                              <div class="period">-->
                    <!--                                <div class="period__label">-->
                    <!--                                  Период-->
                    <!--                                </div>-->
                    <!--                                <div class="period__list">-->
                    <!--                                {{ moment(item.created_at).format('DD.MM.YYYY')}} &mdash;-->
                    <!--                                {{ moment(item.subscription.subscription_finish_date).format('DD.MM.YYYY')}}-->
                    <!--                                </div>-->
                    <!--                              </div>-->
                    <!--                              <div class="subscription">-->
                    <!--                                <h4>Тариф &laquo; &raquo;</h4>-->
                    <!--                                <div class="subscription__info">-->
                    <!--                                  <div class="subscription__label">{{ item.subscription.users_count }} пользователя</div>-->
                    <!--                                  <div class="subscription__value">Х руб.</div>-->
                    <!--                                </div>-->
                    <!--                                <div class="subscription__info">-->
                    <!--                                  <div class="subscription__label">{{ item.subscription.organizations_count }} организаций</div>-->
                    <!--                                  <div class="subscription__value">Х руб.</div>-->
                    <!--                                </div>-->
                    <!--                              </div>-->
                    <!--                              <div class="subscription__info">-->
                    <!--                                <div class="subscription__label"><strong>Итого</strong></div>-->
                    <!--                                <div class="subscription__value"><strong>{{item.cost}} руб.</strong></div>-->
                    <!--                              </div>-->
                    <!--                              <div class="subscription__info">-->
                    <!--                                <div class="subscription__label">НДС</div>-->
                    <!--                                <div class="subscription__value">0 руб.</div>-->
                    <!--                              </div>-->
                    <!--                              <hr />-->
                    <!--                              <div class="subscription__info">-->
                    <!--                                <div class="subscription__label">Оплачено</div>-->
                    <!--                                <div class="subscription__value">0 руб.</div>-->
                    <!--                              </div>-->
                    <!--                              <div class="subscription__info">-->
                    <!--                                <div class="subscription__label">Ожидается оплата</div>-->
                    <!--                                <div class="subscription__value">{{item.cost}} руб.</div>-->
                    <!--                              </div>-->
                    <!--&lt;!&ndash;                              Количество пользователей: {{ item.subscription.users_count }}<br/>&ndash;&gt;-->
                    <!--&lt;!&ndash;                              Количество организаций: {{ item.subscription.organizations_count }}<br/>&ndash;&gt;-->
                    <!--&lt;!&ndash;                              Подключенные сервисы: {{ item.subscription.services.map((item) => item.name).join(', ') }}&ndash;&gt;-->
                    <!--                            </v-col>-->
                    <!--                          </v-container>-->
                    <!--                        </v-card-text>-->
                    <!--                    </v-dialog>-->
                  </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="item.operation_type === 1 && item.payments[0] && item.payments[0].invoice_id"
                             @click="downloadInvoice(item.payments[0].invoice_id)">
                  <v-list-item-title>скачать счет</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="item.operation_type === 1 &&  item.payments[0] && item.payments[0].invoice_id && item.operation_state === 1"
                             @click="deleteInvoice(item)">
                  <v-list-item-title>удалить счет</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <!--            <ul v-if="isShowed(item.id)">-->
            <!--              <li>скачать счет</li>-->
            <!--              <li>-->

            <!--              </li>-->
            <!--            </ul>-->
          </template>
        </v-data-table>
      </div>
    </div>
    <div class="backdrop" v-if="show_card" @click="closeModal"/>
    <dialog class="ais24--dialog" id="finalCalculation" data-type="popup" :open="show_card" v-if="invoiceItem.subscription">
      <button class="ais24--dialog__close" type="button" @click="closeModal">&times;</button>
      <div class="ais24--dialog__content">
        <div class="ais24--final-calculation">
          <div class="ais24--final-calculation__invoice">Счёт
            <mark @click="downloadInvoice(invoiceItem.payments[0].invoice_id)">{{ invoiceItem.id }}</mark>
          </div>
          <div class="ais24--final-calculation__payment">
            <div class="ais24--final-calculation__payment-total">
              {{ invoiceItem.cost }} ₽
            </div>
            <div class="ais24--final-calculation__payment-status">
              <span class="ais24--label ais24--label--danger" v-if="invoiceItem.operation_state === 1">Не оплачен</span>
              <span class="ais24--label ais24--label--success" v-if="invoiceItem.operation_state === 2">Оплачен</span>
            </div>
          </div>
          <div class="ais24--final-calculation__period">
            <span class="ais24--final-calculation__period-caption">Период</span>
            <span class="ais24--final-calculation__period-date">
                                  {{ startDate(invoiceItem).format('DD.MM.YYYY') }} &mdash;
                                  {{ moment(invoiceItem.subscription.subscription_finish_date).format('DD.MM.YYYY') }}
                                </span>
          </div>
          <div class="ais24--final-calculation__rate">
            <div class="ais24--final-calculation__rate-title">Тариф
              <q>{{ invoiceItem.subscription.subscription.name }}</q>
            </div>
            <ul class="ais24--final-calculation__rate-list">
              <li class="ais24--final-calculation__rate-item">
                                  <span class="ais24--final-calculation__rate-caption">
                                    {{ invoiceItem.subscription.users_count }} пользователя</span>
                <span class="ais24--final-calculation__rate-total">
                                  {{
                    invoiceItem.price_per_user * invoiceItem.subscription.users_count * invoiceItem.subscription.period
                  }} ₽
                                </span></li>
              <li class="ais24--final-calculation__rate-item"><span
                  class="ais24--final-calculation__rate-caption">
                                  {{ invoiceItem.subscription.organizations_count }} организации</span><span
                  class="ais24--final-calculation__rate-total">
                                  {{
                  invoiceItem.price_per_org * invoiceItem.subscription.organizations_count * invoiceItem.subscription.period
                }} ₽
                                </span></li>
            </ul>
            <div class="ais24--final-calculation__rate-discount"
                 v-if="invoiceItem.discount_size > 0">Скидка за {{ invoiceItem.subscription.period }} мес.
              <strong>{{ invoiceItem.discount }} ₽ ({{ invoiceItem.discount_size }}%)</strong></div>
            <!--                                <li class="ais24&#45;&#45;final-calculation__rate-item" >-->
            <!--                                  <span class="ais24&#45;&#45;final-calculation__rate-caption">-->
            <!--                                    Скидка {{ invoiceItem.subscription.discount }}% за {{ invoiceItem.subscription.period }} месяцев-->
            <!--                                  </span>-->
            <!--                                  <span class="ais24&#45;&#45;final-calculation__rate-total">-->
            <!--                                    {{-->
            <!--                                      parseInt((-->
            <!--                                      (invoiceItem.subscription.price.price_per_user * invoiceItem.subscription.users_count) * (100 - invoiceItem.subscription.discount) / 100 +-->
            <!--                                      invoiceItem.subscription.price.price_per_organization * invoiceItem.subscription.organizations_count  * (100 - invoiceItem.subscription.discount) / 100-->
            <!--                                      ) * invoiceItem.subscription.period)-->
            <!--                                    }} ₽-->
            <!--                                  </span>-->
            <!--                                </li>-->
            <!--                              </ul>-->
          </div>
          <div class="ais24--final-calculation__amount">
            <div class="ais24--final-calculation__amount-total">
              <ul class="ais24--final-calculation__amount-list">
                <li class="ais24--final-calculation__amount-item">
                  <div class="ais24--final-calculation__amount-caption"><strong>Итого</strong></div>
                  <div class="ais24--final-calculation__amount-value">
                    <strong>{{ invoiceItem.cost  }}
                      ₽</strong></div>
                </li>
                <li class="ais24--final-calculation__amount-item">
                  <div class="ais24--final-calculation__amount-caption">НДС</div>
                  <div class="ais24--final-calculation__amount-value">0,00 ₽</div>
                </li>
              </ul>
            </div>
            <div class="ais24--final-calculation__amount-status">
              <ul class="ais24--final-calculation__amount-list">
                <li class="ais24--final-calculation__amount-item">
                  <div class="ais24--final-calculation__amount-caption">Оплачено</div>
                  <div class="ais24--final-calculation__amount-value"
                       v-if="invoiceItem.operation_state === 1">0 ₽
                  </div>
                  <div class="ais24--final-calculation__amount-value"
                       v-if="invoiceItem.operation_state === 2">{{
                      invoiceItem.cost
                    }} ₽
                  </div>
                </li>

                <li class="ais24--final-calculation__amount-item" v-if="invoiceItem.balance > 0">
                  <div class="ais24--final-calculation__amount-caption">С баланса</div>
                  <div class="ais24--final-calculation__amount-value"> {{ invoiceItem.balance }} ₽</div>
                </li>


                <li class="ais24--final-calculation__amount-item">
                  <div class="ais24--final-calculation__amount-caption">Ожидается оплата</div>
                  <div class="ais24--final-calculation__amount-value"
                       v-if="invoiceItem.operation_state === 2">0 ₽
                  </div>
                  <div class="ais24--final-calculation__amount-value"
                       v-if="invoiceItem.operation_state === 1">{{
                      invoiceItem.cost - invoiceItem.balance - invoiceItem.discount
                    }} ₽
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </dialog>
  </div>
</template>


<style scoped>
table.invoices {
  width: 100%;
  border-collapse: collapse;

  td {
    padding: 10px;
  }
}

.pointer {
  cursor: pointer;
}

.cost {
  font-size: 20px;
  color: #333;
  font-weight: bold;
}

.payment-paid {
  font-size: 12px;
  color: #fff;
  background: #5cb43d;
  padding: 2px 8px;
  border-radius: 6px;
}

.payment-unpaid {
  font-size: 12px;
  color: #fff;
  background: #f95252;
  padding: 2px 8px;
  border-radius: 6px;
}

.period {
  overflow: hidden;

  .period__label {
    float: left;
  }

  .period__list {
    float: right;
  }
}

.subscription {
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 20px;
}

.subscription__info {
  overflow: hidden;

  .subscription__label {
    float: left;
  }

  .subscription__value {
    float: right;
  }
}

.bg-success,
.bg-danger {
  display: inline-block;
  background: #ddd;
  padding: 5px 10px;
  border-radius: 7px;
  margin: 5px 0;
  font-size: 12px;
  line-height: 14px;
  color: #333;
  width: 70px;
  text-align: center;
}

.bg-success {
  background: #3d9563;
  color: #fff;
}
.show-final-calculation{
  cursor: pointer;
}
</style>
